import { useParams } from 'react-router-dom';
import { Btn } from '@/components/Btn';
import { useI18n } from '@/i18n/I18nProvider';
import { usePayments } from '@/api/queries';
import { PageHeading } from '@/components/PageHeading';
import { PaymentList } from '@/components/PaymentList';
import { EmptyState, ErrorState, LoadingState } from '@/components/States';

/** `/a/:cid/payments`: date, amount, reference, which invoices each payment paid, any unapplied remainder. */
export function PaymentsScreen() {
  const { cid = '' } = useParams();
  const { t } = useI18n();
  const query = usePayments(cid);
  const items = query.data?.pages.flatMap((p) => p.items) ?? [];
  const nextPageError: unknown = query.isFetchNextPageError ? query.error : null;
  return (
    <div className="flex flex-col gap-500" data-screen="PaymentsScreen">
      <PageHeading>{t('payments.heading')}</PageHeading>
      {query.isPending ? (
        <LoadingState rows={5} />
      ) : query.isError && items.length === 0 ? (
        <ErrorState error={query.error} onRetry={() => void query.refetch()} />
      ) : items.length === 0 ? (
        <EmptyState>{t('empty.payments')}</EmptyState>
      ) : (
        <div className="flex flex-col items-center gap-400">
          <div className="w-full">
            <PaymentList items={items} cid={cid} caption={t('payments.heading')} />
          </div>
          {query.hasNextPage && (
            <Btn type="button" variant="secondary" size="lg" className="min-h-[48px]" loading={query.isFetchingNextPage} disabled={query.isFetchingNextPage} onClick={() => void query.fetchNextPage()}>
              {t('invoices.loadMore')}
            </Btn>
          )}
          {nextPageError ? <ErrorState error={nextPageError} onRetry={() => void query.fetchNextPage()} className="w-full" /> : null}
        </div>
      )}
    </div>
  );
}
